<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container>
  <router-outlet></router-outlet>
</mat-sidenav-container>
